/**
 * Feature Flags Configuration
 *
 * This file controls feature toggles for the application.
 */

interface FeatureFlags {
  /**
   * USE_BACKEND_API
   *
   * Controls the source of client event images:
   * - true: Fetch images dynamically from the backend API (localhost:3001)
   * - false (default): Use static JSON file (src/data/clientImagesData.json)
   *
   * For production builds, this should be false.
   * For development with image uploads, set to true.
   */
  USE_BACKEND_API: boolean;
}

export const features: FeatureFlags = {
  USE_BACKEND_API: process.env.REACT_APP_USE_BACKEND === 'true' || false,
};

// Export individual flags for easier imports
export const USE_BACKEND_API = features.USE_BACKEND_API;
